/* globals translation */

import { closestByClassName, triggerEvent } from './functions';


const dataLayerQuickView = (quickViewWrapper) => {
  const productId = quickViewWrapper.querySelector('input[name="gtm4wp_id"]');
  const productName = quickViewWrapper.querySelector('input[name="gtm4wp_name"]');
  const productCategory = quickViewWrapper.querySelector('input[name="gtm4wp_category"]');
  const productPrice = quickViewWrapper.querySelector('input[name="gtm4wp_price"]');

  window.dataLayer.push({
    event: 'view_item',
    ecommerce: {
      currency: 'NOK',
      items: [
        {
          google_business_vertical: 'retail',
          id: productId.value,
          item_brand: '',
          item_category: productCategory.value,
          item_id: productId.value,
          item_name: productName.value,
          price: productPrice.value,
        },
      ],
      value: productPrice.value,
    },
  });
};


setTimeout(() => {
  document.addEventListener('click', (event) => {
    const { target } = event;

    if (target && target.matches('.toggle-product-quick-view')) {
      event.preventDefault();
      const link = target;
      const parent = link.parentNode;
      const { productId } = link.dataset;
      const popUp = parent.parentNode.getElementsByClassName('product-quick-view');

      if (popUp.length > 0) {
        popUp[0].classList.add('open');
        dataLayerQuickView(popUp[0]);
      } else {
        link.classList.add('wait');
        jQuery.post(translation.ajaxurl, { action: 'maksimer_product_quick_view', productId }, (response) => {
          parent.insertAdjacentHTML('afterend', response);
          link.classList.remove('wait');
          triggerEvent(document.body, 'quick-view-loaded');

          const addedPopUp = parent.parentNode.getElementsByClassName('product-quick-view');
          if (addedPopUp) {
            dataLayerQuickView(addedPopUp[0]);
          }
        });
      }
    }
  });
}, 100);

document.addEventListener('click', (event) => {
  const { target } = event;

  if (target && target.matches('.product-quick-view-bg')) {
    target.parentNode.classList.remove('open');
  }
});


/**
 * Adds ajax support to the add to cart form in the quick view
 */
jQuery(document).on('submit', '.product-quick-view .product-description .add-to-cart-wrapper .cart', (e) => {
  e.preventDefault();
  const form = e.target;
  const quickViewWrapper = closestByClassName(form, 'product-quick-view');
  const quantityField = form.querySelector('input.qty');
  const productIDField = form.querySelector('input[name=product_id]');
  const submitButton = form.querySelector('.single_add_to_cart_button');

  // Try to find the product ID, different location based on simple og variable product
  const productID = productIDField ? productIDField.value : submitButton.value;

  // Fetch the quantity value
  const quantity = quantityField.value;

  // Variation ID defaults for 0
  let variationID = 0;

  // If it's a variable product, fetch the active variable product ID
  if (quickViewWrapper.classList.contains('product-type-variable')) {
    const chosenVariant = quickViewWrapper.querySelector('ul.sweet-variations li a.choose-variation.active-option');
    variationID = chosenVariant.dataset.variation_id;
  }

  // The ajax request payload
  const payload = {
    action: 'maksimer_woocommerce_ajax_add_to_cart',
    product_id: productID,
    variation_id: variationID,
    quantity,
  };

  // Add loading info
  form.classList.remove('added');
  form.classList.add('loading');

  // Look for info about product being added using ajax
  const existingAddedOutput = quickViewWrapper.querySelector('.ajax-add-product-output');

  // If if have any old info, remove it so we can insert the information again later
  if (existingAddedOutput) {
    existingAddedOutput.remove();
  }

  const productId = quickViewWrapper.querySelector('input[name="gtm4wp_id"]');
  const productName = quickViewWrapper.querySelector('input[name="gtm4wp_name"]');
  // const product_sku = quickViewWrapper.querySelector('input[name="gtm4wp_sku"]');
  const productCategory = quickViewWrapper.querySelector('input[name="gtm4wp_category"]');
  const productPrice = quickViewWrapper.querySelector('input[name="gtm4wp_price"]');
  // const product_stocklevel = quickViewWrapper.querySelector('input[name="gtm4wp_stocklevel"]');

  if (productId) {
    window.dataLayer.push({
      event: 'add_to_cart',
      ecommerce: {
        currency: 'NOK',
        items: [
          {
            google_business_vertical: 'retail',
            id: productId.value,
            item_brand: '',
            item_category: productCategory.value,
            item_id: productId.value,
            item_name: productName.value,
            price: productPrice.value,
            quantity,
          },
        ],
        value: productPrice.value,
      },
    });
  }

  // Create the ajax response output element
  const htmlObject = document.createElement('span');
  htmlObject.className = 'ajax-add-product-output';

  // Post the add to cart request
  jQuery.post(translation.ajaxurl, payload, (response) => {
    // If anything fails, exit here and display info about the error
    if (response.error && response.product_url) {
      form.classList.remove('loading');

      htmlObject.classList.add('error');
      htmlObject.innerText = translation.product_not_added_to_cart;

      submitButton.parentNode.appendChild(htmlObject);

      return null;
    }

    // If it reach this part, the product have been added to the cart
    triggerEvent(document.body, 'wc_fragment_refresh');

    // Inside of a timout to "sync" things a bit better with 'wc_fragment_refresh' - never looked for a better way of doing it
    setTimeout(() => {
      // Remove loading info
      form.classList.remove('loading');
      form.classList.add('added');

      // Reset the quantity back to one
      quantityField.value = 1;

      // Insert the info about product being added to cart
      htmlObject.classList.add('success');
      htmlObject.innerText = translation.product_added_to_cart;

      // Insert info about product being added successfully
      submitButton.parentNode.appendChild(htmlObject);
    }, 1500);

    return null;
  });
});
